<template>
  <div>
    <div class="hm-headline">
      <span class="headline">任务管理</span>
      <span class="subhead"
        >活动任务管理-{{ type === "edit" ? "编辑" : "新增" }}任务</span
      >
    </div>
    <el-card>
      <el-form
        label-position="top"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
      >
        <el-form-item label="任务名称：" prop="taskName">
          <el-input
            v-model="ruleForm.taskName"
            placeholder="任务名称"
            size="small"
            :disabled="isPreview"
          ></el-input>
        </el-form-item>
        <el-form-item label="任务时间：" prop="taskTime">
          <el-date-picker
            value-format="yyyy-MM-dd"
            v-model="ruleForm.taskTime"
            :disabled="isPreview"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择门店：" prop="storeOutletId">
          <el-select
            size="small"
            filterable
            clearable
            placeholder="选择门店"
            :disabled="isPreview"
            v-model="ruleForm.storeOutletId"
            class="width-auto mr10"
            @change="switchStore"
          >
            <el-option
              v-for="item in storeList"
              :key="item.value"
              :label="item.name"
              :value="String(item.id)"
            >
            </el-option>
          </el-select>
          <span class="form-tip">选择门店，再筛选导购均属于所选门店下</span>
        </el-form-item>
        <el-form-item label="导购筛选：" class="isRequired filter-guider">
          <div class="hm-form-container">
            <div class="transfer-panel">
              <el-input
                size="small"
                clearable
                placeholder="导购名称或手机号"
                v-model.trim="keywords"
                class="mr10"
                :disabled="isPreview || ruleForm.storeOutletId === ''"
              ></el-input>
              <el-button
                size="small"
                :disabled="isPreview || ruleForm.storeOutletId === ''"
                type="primary"
                @click="searchTarget"
                >查询</el-button
              >
            </div>
            <hm-transfer
              @getGuiderCount="getGuiderCount"
              :isPreview="isPreview"
              transferMode="filterGuider"
              background="danger"
              leftName="所有导购"
              rightName="给下列导购安排任务"
              :leftOption="leftGuiderList"
              ref="guideTransfer"
            ></hm-transfer>
          </div>
        </el-form-item>
        <el-form-item label="会员基础筛选：" class="isRequired">
          <div class="hm-form-container">
            <el-radio-group v-model="model" size="small" :disabled="isPreview">
              <el-radio-button :label="0">自动筛选</el-radio-button>
              <el-radio-button :label="1">手动筛选</el-radio-button>
            </el-radio-group>
            <!-- 自动筛选 -->
            <div v-show="model === 0">
              <el-radio-group
                v-model="isMom"
                size="small"
                :disabled="isPreview"
              >
                <el-radio :label="0">
                  有宝宝
                </el-radio>
                <el-radio :label="1">
                  孕期
                </el-radio>
              </el-radio-group>
              <!-- 选择有宝宝 -->
              <div class="flex" v-show="isMom === 0">
                <div class="mr10">
                  <div>宝宝性别</div>
                  <el-select
                    size="small"
                    filterable
                    v-model="babyGender"
                    placeholder=""
                    :disabled="isPreview"
                  >
                    <el-option label="所有" value="0"></el-option>
                    <el-option
                      v-for="(v, i) in babyGenderList"
                      :label="v.featureName"
                      :value="v.featureCode"
                      :key="i"
                    ></el-option>
                  </el-select>
                </div>
                <div>
                  <div>宝宝年龄段</div>
                  <el-select
                    size="small"
                    filterable
                    v-model="babyAge"
                    placeholder=""
                    :disabled="isPreview"
                  >
                    <el-option label="所有" value="0"></el-option>
                    <el-option
                      v-for="(v, i) in babyAgeList"
                      :label="v.featureName"
                      :value="v.featureCode"
                      :key="i"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <!-- 选择孕期 -->
              <div v-show="isMom === 1">
                <div class="mr10">
                  <div>孕期信息</div>
                  <el-select
                    size="small"
                    filterable
                    v-model="pregnancy"
                    placeholder=""
                    :disabled="isPreview"
                  >
                    <el-option label="所有" value="0"></el-option>
                    <el-option
                      v-for="(v, i) in pregnancyList"
                      :label="v.featureName"
                      :value="v.featureCode"
                      :key="i"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div class="flex">
                <div class="mr10">
                  <div>消费能力</div>
                  <el-select
                    size="small"
                    filterable
                    v-model="consumeLevel"
                    placeholder=""
                    :disabled="isPreview"
                  >
                    <el-option label="所有" value="0"></el-option>
                    <el-option
                      v-for="(v, i) in consumptionLevelList"
                      :label="v.featureName"
                      :value="v.featureCode"
                      :key="i"
                    ></el-option>
                  </el-select>
                </div>
                <div>
                  <div>客户活跃度</div>
                  <el-select
                    size="small"
                    filterable
                    v-model="memberActiveLevel"
                    placeholder=""
                    :disabled="isPreview"
                  >
                    <el-option label="所有" value="0"></el-option>
                    <el-option
                      v-for="(v, i) in customerActivityList"
                      :label="v.featureName"
                      :value="v.featureCode"
                      :key="i"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <!-- 手动筛选 -->
            <div v-show="model === 1">
              <div>
                <span class="form-tip"
                  >注：导入格式需按照用户名、电话、名单来源顺序导入，用户名和名单来源可选填，导入同名文件请刷新后再导入，数据量过大时将会造成页面卡顿！</span
                >
              </div>
              <div class="flex flex-between input-panel">
                <div>选择分配的会员</div>
                <div>
                  <el-button size="small" @click="output">导出模板</el-button>
                  <el-button
                    type="primary"
                    class="open-file"
                    size="small"
                    :disabled="isPreview"
                  >
                    导入数据
                    <input
                      :disabled="isPreview"
                      type="file"
                      @change="importf"
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    />
                  </el-button>
                </div>
              </div>
              <div class="scroll-wrapper">
                <el-table :data="inputData" border class="small-table">
                  <el-table-column prop="name" label="用户名">
                  </el-table-column>
                  <el-table-column prop="mobile" label="手机号">
                  </el-table-column>
                  <el-table-column prop="source" label="名单来源">
                  </el-table-column>
                </el-table>
                <div class="error" v-show="inputData.length <= 0">
                  请导入分配的会员
                </div>
              </div>
            </div>
          </div>
        </el-form-item>
        <div v-show="model === 0">
          <div class="deal-title">
            <span class="required">*</span>会员消费筛选
          </div>
          <div class="hm-form-container">
            <el-form-item label="品类列表筛选：">
              <el-select
                size="small"
                filterable
                clearable
                placeholder="选择品类"
                :disabled="isPreview"
                v-model="buyCategory"
                class="mr10"
                remote
                :remote-method="remoteMethod"
                :loading="loading"
                @change="getLabel"
              >
                <el-option
                  v-for="(item, i) in realTimeCat"
                  :key="i"
                  :label="item.categoryName"
                  :value="item.categoryId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="品牌列表筛选：">
              <el-select
                size="small"
                filterable
                clearable
                placeholder="选择品牌"
                :disabled="isPreview"
                v-model="buyBrands"
                class="mr10"
              >
                <el-option
                  v-for="(item, i) in offlineBrandList"
                  :key="i"
                  :label="item.name"
                  :value="item.objectId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品货号筛选：">
              <el-input
                v-model="goodsSn"
                placeholder="输入商品货号"
                size="small"
                :disabled="isPreview"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="商城会员筛选：">
              <el-select
                size="small"
                filterable
                clearable
                placeholder="选择商城会员"
                :disabled="isPreview"
                v-model="isStoreMember"
                class="mr10"
              >
                <el-option label="所有" value="0"> </el-option>
                <el-option label="商城会员" value="1"> </el-option>
                <el-option label="非商城会员" value="2"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="购买时间筛选">
              <el-date-picker
                value-format="yyyy-MM-dd"
                :disabled="isPreview"
                v-model="buyTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
              >
              </el-date-picker>
            </el-form-item>
            <div
              class="error"
              v-show="
                !buyCategory &&
                  !buyBrands &&
                  !goodsSn &&
                  !isStoreMember &&
                  (!buyTime || buyTime.length <= 0)
              "
            >
              请筛选会员消费条件
            </div>
          </div>
        </div>
        <div class="btn-wrapper text-center">
          <el-button
            size="small"
            type="primary"
            round
            @click="preview"
            v-show="!isPreview"
            :disabled="model === 1 && avergeManual <= 0"
            :loading="isPreviewing"
            >预览并发布</el-button
          >
          <el-button
            size="small"
            type="primary"
            round
            @click="publish"
            v-show="isPreview"
            :disabled="isPreviewing"
            :loading="isPublishing"
            >发布</el-button
          >
          <el-button size="small" round @click="back">返回</el-button>
        </div>
      </el-form>
      <div id="dragContainer">
        <div id="dragbleElement" class="preview-container">
          <div class="tag">
            结论展示
          </div>
          <div class="tip">
            若筛选会员数小于筛选导购数则无法发布！
          </div>
          <div class="content">
            <div class="content-item">
              <div>筛选导购</div>
              <span class="guider">{{ guiderCount }}</span>
            </div>
            <div class="content-item">
              <div>筛选会员</div>
              <span class="guider" v-show="model === 0">{{ memberCount }}</span>
              <span class="guider" v-show="model === 1">{{
                inputData.length || 0
              }}</span>
            </div>
            <div class="content-item">
              <div>导购平均分配数</div>
              <span class="score" v-show="model === 0">{{ averge }}</span>
              <span class="score" v-show="model === 1">{{ avergeManual }}</span>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { drag } from "../../utils/utils.js";
import { mapState, mapGetters } from "vuex";
import HmTransfer from "@/components/HmCouponTransfer";
import XLSX from "xlsx";

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: { HmTransfer },
  data() {
    return {
      type: this.$route.params.type,
      taskId: this.$route.params.taskId,
      selectedCats: false,
      isPreview: false,
      isPreviewing: false,
      buyTime: [],
      model: 0,
      memberCount: 0,
      isStoreMember: "",
      realTimeCat: [],
      buyBrands: "",
      leftGuiderList: [],
      buyCategory: "",
      buyCategoryName: "",
      avergeManual: 0,
      goodsSn: "",
      isMom: 0,
      isPublishing: false,
      guiderCount: 0,
      babyGender: "0",
      babyAge: "0",
      pregnancy: "0",
      consumeLevel: "0",
      memberActiveLevel: "0",
      ruleForm: {
        taskName: "",
        taskTime: [],
        storeOutletId: ""
      },
      isSaving: false,
      inputData: [],
      rules: {
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" }
        ],
        taskTime: [
          { required: true, message: "请选择任务时间", trigger: "blur" }
        ],
        storeOutletId: [
          { required: true, message: "请选择门店", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    if (this.type === "edit") {
      this.$store.dispatch("queryFilledTask", {
        taskId: this.taskId,
        model: this.$route.params.model
      });
    }
  },
  mounted() {
    this.$store.dispatch("querySpecialTarget");
    this.$store.dispatch("queryStore");
    this.$store.dispatch("queryOfflineBrand");
    const dragbleElement = document.getElementById("dragbleElement");
    const dragContainer = document.getElementById("dragContainer");
    drag.startDrag(dragContainer, dragbleElement);
  },
  computed: {
    averge() {
      let result = 0;
      if (this.guiderCount) {
        if (this.guiderCount === 0) {
          result = 0;
        } else {
          result = Number.isInteger(this.memberCount / this.guiderCount)
            ? this.memberCount / this.guiderCount
            : (this.memberCount / this.guiderCount).toFixed(2);
          result = Math.floor(result);
        }
      }
      return result;
    },
    ...mapGetters([
      "offlineCatList",
      "filedTaskMemberList",
      "updateTaskCode",
      "filedTaskGuiderList",
      "filedTaskInfo",
      "filterMemberList",
      "publishTaskCode",
      "totalMemberCount",
      "filterMemberCode"
    ]),
    ...mapState({
      storeList: state => state.rules.storeList,
      guiderList: state => state.rules.guiderList,
      babyGenderList: state => state.rules.babyGenderList,
      babyAgeList: state => state.rules.babyAgeList,
      consumptionLevelList: state => state.rules.consumptionLevelList,
      customerActivityList: state => state.rules.customerActivityList,
      pregnancyList: state => state.rules.pregnancyList,
      categoryList: state => state.rules.categoryList,
      offlineBrandList: state => state.rules.offlineBrandList
    })
  },
  watch: {
    inputData(val) {
      if (val.length > 0) {
        this.getAvergeCount();
      }
    },
    filterMemberCode(val) {
      if (val === "0" || val === "-1") {
        this.isPreviewing = false;
      }
    },
    totalMemberCount(val) {
      this.memberCount = val;
    },
    offlineCatList(val) {
      if (val.length > 0) {
        this.realTimeCat = val;
      }
    },
    updateTaskCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.$router.push({ name: "taskManagement" });
      }
      this.isPublishing = false;
      this.$store.commit("updateTask", "");
    },
    filedTaskInfo(val) {
      if (val) {
        for (let key in val) {
          if (this.hasOwnProperty(key)) {
            this[key] = val[key];
          }
        }
        this.isStoreMember = String(this.isStoreMember);
        this.ruleForm.taskName = val.taskName;
        this.ruleForm.storeOutletId = val.storeOutletId;
        this.ruleForm.taskTime = [val.startTime, val.endTime];
        this.buyCategory = val.buyCategoryName;
        this.buyTime = val.consumeDateStart
          ? [val.consumeDateStart, val.consumeDateEnd]
          : [];
        this.memberCount = val.memberNum;
      }
    },
    filedTaskGuiderList(val) {
      if (val && val.length > 0) {
        this.guiderCount = this.filedTaskGuiderList.length;
        this.$refs.guideTransfer.rightData = val;
        this.$refs.guideTransfer.rightCheckAll = true;
        this.$refs.guideTransfer.rightChecked = val;
      }
    },
    filedTaskMemberList(val) {
      if (val && val.length > 0) {
        this.inputData = val;
      }
    },
    guiderList(val) {
      if (val) {
        this.leftGuiderList = val;
      }
    },
    model(val) {
      // 自动筛选
      if (val === 1) {
        // 手动筛选
        this.getAvergeCount();
      }
    },
    publishTaskCode(val) {
      if (val === "0") {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.$router.push({ name: "taskManagement" });
      }
      this.isPublishing = false;
      this.$store.commit("publishTask", "");
    }
  },
  methods: {
    publish() {
      const isFilterGuider = this.$refs.guideTransfer.rightChecked.length > 0;
      const guiderIdList = [];
      this.$refs.guideTransfer.rightChecked.forEach(v => {
        guiderIdList.push(v.id || v.guiderIds);
      });
      const isTaskValid =
        this.model === 1 ? guiderIdList.length <= this.inputData.length : true;
      if (!isTaskValid) {
        this.$message({
          message: "导购筛选数量应小于手动筛选会员数量！",
          type: "warning"
        });
      }
      const isFilterMember =
        this.model === 0 || (this.model === 1 && this.inputData.length > 0);
      const isSelectedMemberConsume =
        this.model === 0
          ? this.buyCategory ||
            this.buyBrands ||
            this.goodsSn ||
            this.isStoreMember ||
            (this.buyTime && this.buyTime.length > 0)
          : true;
      let params = {
        taskName: this.ruleForm.taskName,
        startTime:
          (this.ruleForm.taskTime &&
            this.ruleForm.taskTime.length > 0 &&
            this.ruleForm.taskTime[0]) ||
          "",
        endTime:
          (this.ruleForm.taskTime &&
            this.ruleForm.taskTime.length > 0 &&
            this.ruleForm.taskTime[1]) ||
          "",
        guiderIds: guiderIdList.join(","),
        storeOutletId: this.ruleForm.storeOutletId,
        model: this.model
      };
      if (this.model === 0) {
        params = Object.assign(params, {
          isMom: this.isMom,
          babyGender: this.isMom === 0 ? this.babyGender : "",
          babyAge: this.isMom === 0 ? this.babyAge : "",
          consumeLevel: this.consumeLevel,
          isStoreMember: this.isStoreMember,
          memberActiveLevel: this.memberActiveLevel,
          pregnancy: this.isMom === 1 ? this.pregnancy : "",
          buyCategory: this.getCatgory(),
          buyBrands: this.buyBrands,
          goodsSn: this.goodsSn,
          buyCategoryName: this.buyCategoryName,
          consumeDateStart:
            (this.buyTime && this.buyTime.length > 0 && this.buyTime[0]) || "",
          consumeDateEnd:
            (this.buyTime && this.buyTime.length > 0 && this.buyTime[1]) || "",
          memberAutoList: this.filterMemberList
        });
      } else {
        params = Object.assign(params, {
          member: this.inputData
        });
      }
      this.$refs.ruleForm.validate(valid => {
        if (
          valid &&
          isSelectedMemberConsume &&
          isFilterMember &&
          isFilterGuider &&
          isTaskValid
        ) {
          this.isPublishing = true;
          if (this.type === "edit") {
            this.$store.dispatch(
              "updateTask",
              Object.assign(params, {
                createTime: this.filedTaskInfo.createTime,
                taskId: this.filedTaskInfo.taskId
              })
            );
          } else {
            this.$store.dispatch("publishTask", params);
          }
        }
        return false;
      });
    },
    searchTarget() {
      this.$store.dispatch("queryGuider", {
        name: this.keywords,
        storeOutletId: this.ruleForm.storeOutletId
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        // this.loading = true
        this.$store.dispatch("queryRealTimeCatOffline", {
          name: query
        });
      } else {
        this.realTimeCat = [];
      }
    },
    getLabel(val) {
      let obj = {};
      obj = this.realTimeCat.find(item => {
        return item.categoryId === val;
      });
      this.buyCategoryName = obj.categoryName;
    },
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        let isValidPhone = true;
        result.forEach(v => {
          if ((v[1] && v[1].length !== 11) || !v[1]) {
            isValidPhone = false;
          }
          formatResult.push({
            name: v[0],
            mobile: v[1],
            source: v[2]
          });
        });
        if (isValidPhone) {
          that.inputData = formatResult;
          that.memberCount = formatResult.length;
        } else {
          that.$message({
            message: "导入失败，错误的电话格式！",
            type: "warning"
          });
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    output() {
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        const tHeader = ["用户名", "手机号", "名单来源"];
        const filterVal = ["name", "mobile", "source"];
        const list = [{ name: "", mobile: "", source: "" }];
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, "导入会员模板");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    getCatgory() {
      let buyCategory = this.buyCategory;
      if (
        this.type === "edit" &&
        this.buyCategory === this.filedTaskInfo.buyCategoryName
      ) {
        buyCategory = this.filedTaskInfo.buyCategory;
      }
      return buyCategory;
    },
    preview() {
      if (this.model === 0) {
        const isFilterGuider = this.$refs.guideTransfer.rightChecked.length > 0;
        const guiderIdList = [];
        this.$refs.guideTransfer.rightChecked.forEach(v => {
          guiderIdList.push(v.id);
        });
        const isTaskValid =
          this.model === 1
            ? guiderIdList.length <= this.inputData.length
            : true;
        const isFilterMember =
          this.model === 0 || (this.model === 1 && this.inputData.length > 0);
        const isSelectedMemberConsume =
          this.model === 0
            ? this.buyCategory ||
              this.buyBrands ||
              this.goodsSn ||
              this.isStoreMember ||
              (this.buyTime && this.buyTime.length > 0)
            : true;
        this.$refs.ruleForm.validate(valid => {
          if (
            valid &&
            isSelectedMemberConsume &&
            isFilterMember &&
            isFilterGuider &&
            isTaskValid
          ) {
            this.isPreview = true;
            this.isPreviewing = true;
            this.$store.commit("queryMemberCount", "");
            this.$store.dispatch("queryMemberCount", {
              isMom: this.isMom,
              babyGender: this.isMom === 0 ? this.babyGender : "",
              babyAge: this.isMom === 0 ? this.babyAge : "",
              consumeLevel: this.consumeLevel,
              buyCategoryName: this.buyCategoryName,
              model: this.model,
              isStoreMember: this.isStoreMember,
              memberActiveLevel: this.memberActiveLevel,
              pregnancy: this.isMom === 1 ? this.pregnancy : "",
              buyCategory: this.getCatgory(),
              buyBrands: this.buyBrands,
              goodsSn: this.goodsSn,
              consumeDateStart:
                (this.buyTime && this.buyTime.length > 0 && this.buyTime[0]) ||
                "",
              consumeDateEnd:
                (this.buyTime && this.buyTime.length > 0 && this.buyTime[1]) ||
                "",
              storeOutletId: this.ruleForm.storeOutletId
            });
          }
          return false;
        });
      } else {
        this.isPreview = true;
      }
    },
    back() {
      if (this.isPreview) {
        this.isPreview = false;
      } else {
        this.$router.back();
      }
    },
    getGuiderCount(val) {
      this.guiderCount = val;
      this.getAvergeCount();
    },
    getAvergeCount() {
      let result = 0;
      const len = this.inputData.length;
      if (len) {
        if (this.guiderCount === 0) {
          result = 0;
        } else {
          result = Number.isInteger(len / this.guiderCount)
            ? len / this.guiderCount
            : (len / this.guiderCount).toFixed(2);
          result = Math.floor(result);
        }
      }
      this.avergeManual = result;
    },
    switchStore() {
      this.guiderCount = 0;
      this.$refs.guideTransfer.rightData = [];
      this.$refs.guideTransfer.rightCheckAll = false;
      this.$refs.guideTransfer.rightChecked = [];
    }
  }
};
</script>

<style scoped lang="scss">
.preview-container {
  position: fixed;
  top: 160px;
  right: 30px;
  width: 160px;
  z-index: 10;
  user-select: none;
  border: 1px solid #c7c7c7;
  border-radius: 5px;
  padding: 10px 0;
  background: #fff;
  cursor: move;
  .tag {
    position: relative;
    background: #4680fe;
    color: #fff;
    padding: 10px 0 10px 0.5rem;
    width: 100px;
  }
  .tag:after {
    position: absolute;
    content: "";
    right: 0;
    top: 0;
    border: 18px solid transparent;
    border-right-color: #fff;
  }
  .content {
    padding: 0 10px;
  }
  .content-item {
    padding-top: 2rem;
    .guider,
    .score {
      font-size: 1.5rem;
    }
    .guider {
      color: #6b94e4;
    }
    .score {
      color: #f5567c;
    }
  }
}

.width-auto {
  width: auto;
}

.hm-form-container {
  max-width: 1098px;
}

.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.input-panel {
  height: 32px;
  margin-bottom: 10px;
  width: 500px;
}
.deal-title {
  height: 28px;
  line-height: 28px;
}
.btn-wrapper {
  margin-top: 2rem;
  height: 33px;
}

.required {
  color: #f56c6c;
  margin-right: 4px;
}
.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}

.tip {
  color: #f5567c;
  padding: 2rem 10px 0;
}

.scroll-wrapper {
  width: 500px;
  height: 403px;
  overflow-y: scroll;
}

.form-tip {
  font-size: 12px;
  color: #999;
  margin-left: 0.5rem;
}

.category-wrpper {
  margin-bottom: 22px;
  > span {
    height: 28px;
    line-height: 28px;
    padding: 0 0 10px;
  }
}
</style>
